export default function getDefaultServices(){
    let services = [];

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "Traditional Photography",
      description:'Capture every moment in its essence with classic photography styles that focus on structured, posed shots and group photos, ensuring every detail of the event is preserved.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "Traditional Videography",
      description:'Document your event seamlessly with continuous video coverage, capturing every scene with a steady, unembellished style for a complete storytelling experience.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "Candid Photography",
      description:'Relive the genuine emotions and unscripted moments of your event through natural, spontaneous shots that reflect the true essence of the occasion.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "Cinematic Shoot",
      description:'Transform your event into a cinematic experience with professional storytelling, creative angles, and artistic editing for a visually captivating video.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "Drone",
      description:'Add a bird’s-eye view to your event with stunning aerial shots that provide dynamic perspectives and showcase the grandeur of the venue.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    services.push({
      id: Math.floor((Math.random() * 10000) + 1),
      title: "LED Wall & Live",
      description:'Enhance audience engagement with real-time event broadcasting on large LED walls, offering a vibrant and immersive viewing experience for attendees.',
      serviceLink: '',
      show: true,
      isValid: false,
      ref: null
    });

    return services;
}